<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            REPORTAJE Y PROPAGANDA: <br>
            <span style="line-height: 100%;" class="fontMS300">
                NOTICIARIOS CINEMATOGRÁFICOS <br> PERUANOS DE LOS 40 <br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio18/noticieros">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio18/noticieros">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio18/noticieros">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio18/NOTIC_000.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 font-24 text-justify">
                    HACIA LA DÉCADA DE 1940, EL CINE SE HABÍA CONSOLIDADO COMO UN MEDIO MASIVO DE COMUNICACIÓN EN TODA AMÉRICA LATINA, 
                    Y TUVO TAL PREPONDERANCIA QUE  COBRÓ PARTICULAR IMPORTANCIA EN LA CONFIGURACIÓN DE NUEVAS IDENTIDADES Y MASIVAS 
                    AUDIENCIAS.
                </p>
                <p class="fontMS100 text-justify font-24">
                    La Biblioteca Nacional preserva rollos de filme de 35 milímetros con noticiarios financiados desde el Estado, entre 
                    1944 y 1948, los cuales se exhibían en las salas de cine previos a la emisión de películas. La digitalización de este 
                    material fílmico, en el 2016, nos permitió acceder al testimonio audiovisual de un período significativo para la historia 
                    del Perú, que abarca la época post conflicto bélico con Ecuador (julio-agosto de 1941), el final de la segunda guerra 
                    mundial, las aperturas modernizadoras, la transición democrática y finalmente, la crisis política que conllevaría a un 
                    nuevo golpe de Estado. La compleja década de 1940, está documentada, además, con noticias sobre deporte, cultura, milicia, 
                    educación, vida cotidiana en Lima y en las demás regiones del país en un esfuerzo descentralizador.
                </p>
            </div>
            <div class="col-sm-12 libro">
                <img class="imagen1" width="100%" height="85%"
                        src="/assets/images/micrositio/micrositio18/NOTIC_001.jpg">
            </div>
            <div class="row">
                <div class="col-sm-6 mt-5 videoReprod">
                    <a id="123" class="video3" style="color: black;">
                        <img width="100%" src="http://img.youtube.com/vi/tJdxIlYigxk/hqdefault.jpg" />
                    </a>
                </div>
                <div class="col-sm-6 mt-5">
                    <img width="100%" 
                            src="/assets/images/micrositio/micrositio18/NOTIC_008.jpg">
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-6 pr-4">
                    <p class="fontMS500 font-24">
                        Biblioteca Digital BNP - Digitalización <br>
                        Documental Audiovisual <br>
                    </p>
                    <p class="fontMS100 font-24">
                        Proceso de digitalización de material documental audiovisual (películas de cine de 35 mm, Betamax, 
                        VHS, DVD; discos de carbón, vinilo, cintas de audio a carrete abierto y casetes) mediante equipos 
                        especializados de conversión donados por el Gobierno de Japón, y llevado a cabo en la Dirección Ejecutiva 
                        de Biblioteca Digital de la BNP, sede San Borja. 
                        Etapas: - Preparación, Captura y Masterización - Edición - Ingreso de metadatos - Codificación y Difusión web. 

                    </p>
                </div>
                <div class="col-sm-6">
                    <p class="fontMS100 font-24">
                        El celuloide es una tira flexible y transparente con perforaciones a sus extremos y de un ancho de 35 milímetros, 
                        inventada a finales del siglo XIX y estandarizado para la fotografía y el cine. Fue el soporte más utilizado para 
                        filmar y exhibir películas, a pesar de sus limitaciones; pues, su composición de nitrato de celulosa era inestable 
                        y se degradaba desde el momento de su fabricación. Era muy sensible a la manipulación, la temperatura y la humedad.
                    </p>
                </div>
            </div>
            <div class="col-sm-12 mb-5">
                <img class="LineSubsec" width="100%"
                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
            </div>

            <div class="row mt-5">
                <div class="col-sm-3">
                    <img class="LineSubsec bottom_cel" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="c100">
                    <img class="lineCel mb-3" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="col-sm-6">
                    <p style="line-height: 160%;margin-bottom: 0%;"
                        class="fontMS700 text-center colorPrincipal font-40">
                        LEY DE NOTICIARIOS
                    </p>
                </div>
                <div class="col-sm-3">
                    <img class="LineSubsec bottom_cel" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    Y PRODUCTORAS
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
            </div>
            <div class="col-sm-12 mt-5">
                <p class="fontMS500 font-24">
                    PARA FINALES DE LA DÉCADA DE LOS TREINTA, LA OPINIÓN PÚBLICA SE EXPRESABA CADA VEZ MÁS A TRAVÉS DE LOS MEDIOS DE 
                    COMUNICACIÓN MASIVOS, COMO LA PRENSA Y LA RADIO, LO QUE LLAMÓ LA ATENCIÓN DE POLÍTICOS Y FUNCIONARIOS PÚBLICOS.
                </p>
            </div>
            <div class="row mt-4">
                <div class="col-sm-4 p-5">
                    <img width="100%" 
                            src="/assets/images/micrositio/micrositio18/NOTIC_002.jpg">
                    <img width="100%" 
                            src="/assets/images/micrositio/micrositio18/NOTIC_003.jpg">
                    <img width="100%"
                            src="/assets/images/micrositio/micrositio18/NOTIC_004.jpg">
                    <img width="100%"
                            src="/assets/images/micrositio/micrositio18/NOTIC_005.jpg">
                </div>
                <div class="col-sm-8">
                    <p class="fontMS100 font-24">
                        De igual manera, desde el Estado mismo, durante el primer gobierno de Manuel Prado (1939-1945) 
                        se implementó una política de propaganda orientada a la difusión de las iniciativas gubernamentales, 
                        capitalizar la victoria sobre el Ecuador luego del conflicto del armado en la frontera norte y la 
                        afirmación de la presencia del Estado en la región amazónica. Aunque no se exhibió en las salas de 
                        cine debido al desarrollo de la resolución diplomática posterior a la guerra, la película Alerta en 
                        la frontera, es un ejemplo de la propaganda oficial: filmada con escenas recreadas en el territorio 
                        en conflicto, incluía a la esposa y la hija del presidente repartiendo víveres a las tropas en el 
                        frente y al mismo Prado en el homenaje realizado en Lima tras la victoria. Prensa, monumentos, 
                        exposiciones y el cine fueron utilizados para alentar el patriotismo. El control se centralizó 
                        a través de la Dirección de Propaganda e Información y la Oficina de Informaciones, ambas adscritas 
                        al Ministerio de Gobierno y Policía. Es aquí donde se planifica el contenido del Servicio de Noticiarios 
                        Nacionales, creado en julio de 1944, y que consistía en la realización de un noticiario de periodicidad 
                        semanal, así como de documentales que debían exhibirse de forma obligatoria en todas las salas de cine 
                        del país. Además, se designaba a la empresa productora que desarrollaría el filme y se pagaba en 
                        relación con el metraje.
                    </p>
                </div>
            </div>
            <div class="col-sm-12 mb-5">
                <img class="LineSubsec" width="100%"
                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
            </div>
            <div class="row mt-5">
                <div class="col-sm-4">
                    <img class="LineSubsec bottom_cel" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="col-sm-4">
                    <p style="line-height: 160%;margin-bottom: 0%;"
                        class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                        EL CINE Y 
                    </p>
                </div>
                <div class="col-sm-4">
                    <img class="LineSubsec bottom_cel" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    USOS DEL ESTADO
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
            </div>
            
            <div class="row mt-5">
                <div class="col-sm-6 pr-5">
                    <p class="fontMS500 font-24">
                        DURANTE LA SEGUNDA GUERRA MUNDIAL (1939-1945) EL REQUERIMIENTO DE CELULOSA PARA LA FABRICACIÓN DE 
                        EXPLOSIVOS CAUSA LA REDUCCIÓN DE LA PRODUCCIÓN DE NEGATIVOS FÍLMICOS E INSUMOS FOTOGRÁFICOS. PARA 
                        MEDIADOS DE LOS CUARENTA LA EXTENSIÓN Y CONSUMO DE LA INDUSTRIA CINEMATOGRÁFICA ERA SIGNIFICATIVA, 
                        YA QUE EL CINE FORMABA PARTE DE LA VIDA COTIDIANA.
                    </p>
                    <br>
                    <img width="100%" 
                            src="/assets/images/micrositio/micrositio18/NOTIC_006.jpg">
                </div>
                <div class="col-sm-6 mt-5">
                    <p class="fontMS100 font-24">
                        <br>
                        Durante ese período existían en Lima alrededor de ochenta salas de cine y recibían una asistencia 
                        diaria de cien mil personas. La filmografía local competía con producciones extranjeras, siendo las 
                        películas mexicanas y argentinas las más exitosas en las salas de barrio de la ciudad. A pesar de 
                        las circunstancias políticas y económicas se puede mencionar a la nacional Amauta Films como la 
                        productora más influyente de dicho período, aunque se inició la paralización de las labores fílmicas 
                        y la liquidación de algunas empresas cinematográficas. Sin embargo, es importante la ambición del 
                        uso del cine dentro de los planes educativos del Estado peruano. En su discurso al congreso de 1944, 
                        Manuel Prado señala su uso en la enseñanza para adultos con películas de carácter cultural, y para 
                        escolares mediante cintas que complementaban las lecciones dictadas por los maestros. Las cifras 
                        para 1942 eran 234 exhibiciones en los diversos planteles de enseñanza pública y privada con una 
                        asistencia de 96,128 espectadores, y que, en 1944, se elevó a 500 exhibiciones, con una asistencia 
                        aproximada de 140,000 espectadores entre escolares, obreros y maestros en diez regiones del país.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_RESALTE.png">
                <br><br>
                <p class="fontMS500 text-justify font-28">
                    «LA IMPLANTACIÓN DEL SERVICIO DE NOTICIARIOS PERUANOS CINEMATOGRÁFICOS, ESTRUCTURA UNA DE LAS MÁS ELEVADAS 
                    CONQUISTAS PARA LA PROPAGANDA NACIONAL Y SE REALIZA ENTRE SUS DILATADAS PROYECCIONES LA IMPLANTACIÓN DEL 
                    PERIODISMO CINEMATOGRÁFICO. ESTE SERVICIO SE PRESENTA YA EN VARIOS PAÍSES DE AMÉRICA Y PROVOCA ELOGIOSOS 
                    COMENTARIOS, TANTO POR SU CONTENIDO ILUSTRATIVO Y SU ORIENTACIÓN AMERICANISTA, CUANTO POR SU EJECUCIÓN 
                    TÉCNICA; LO QUE ABRE UN NUEVO CAMPO DE ACTIVIDADES PROVECHOSAS PARA EL ARTE Y LA COLABORACIÓN INTELECTUAL».
                </p>
                <p class="fontMS500Italic font-28 text-right">
                    MANUEL PRADO, MENSAJE DEL PRESIDENTE DEL PERÚ ANTE EL<br> CONGRESO NACIONAL, 28 DE JULIO DE 1945
                </p>
                <img id="img_rotate" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_RESALTE.png">
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            PODER Y CONFLICTO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    POLÍTICO &nbsp;
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="col-sm-12 mt-5">
                    <p class="fontMS500 font-24 text-white">
                        LA DÉCADA DE 1940 PARECÍA TENER CIERTA ESTABILIDAD POLÍTICA DEBIDO A LA CONTINUIDAD DE GOBIERNOS 
                        ELEGIDOS POR SUFRAGIO Y DE MANERA DEMOCRÁTICA. SIN EMBARGO, UN RÁPIDO DETERIORO ENTRE EL EJECUTIVO 
                        Y EL LEGISLATIVO Y LA AGUDIZACIÓN DE LAS TENSIONES SOCIALES, FINALIZA DE MANERA DRAMÁTICA EN UN 
                        GOLPE DE ESTADO MILITAR.
                    </p>
                    <br>
                    <p class="fontMS100 font-24 text-white">
                        Los noticiarios seleccionados cubren las últimas visitas protocolares del primer gobierno de Manuel 
                        Prado incluyendo su viaje a Tumbes años después del conflicto armado con Ecuador de 1941. Además, 
                        cubren la toma de mando de José Luis Bustamante y Rivero, vencedor de las elecciones de 1945 con 
                        apoyo del APRA, partido declarado ilegal entre 1932 y 1945. En 1948, la inestabilidad política 
                        precipita el derrocamiento del gobierno por el anterior ministro de Policía, Manuel Odría.
                    </p>
                    <br><br>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70957" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/gEwK5GzhtPU/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            La integridad territorial se afirma
                        </p>
                        
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70856" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/sSu9KHEiJHk/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            El presidente visita la ciudad de Canta 
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71208" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/NqXENs6CErM/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            En la cuenca carbonífera de Oyón  
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70669" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/iSkV_qbY8iw/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Transmisión del mando supremo... 
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71139" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/FD2x1aMH90Y/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Toma de mando del presidente...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71251" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/LNI9Sk9aR_4/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Almuerzo en honor del presidente...
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3" >
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70526" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/bg7rEX4UKqw/maxresdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Cusco recibe al presidente...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70490" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/H3rXOe0GM2k/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Entierro de oficiales, cadetes y tropa...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container_Azul_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            EL DEPORTE
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    PARA PROGRESAR
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="col-sm-12 mt-5">
                    <p class="fontMS500 font-24 text-white text-justify">
                        EL DEPORTE ESTUVO ASOCIADO A LA NOCIÓN DE EJERCICIO FÍSICO COMO ELEMENTO INDISPENSABLE PARA EL PROGRESO 
                        Y COMO FORMADOR DEL CARÁCTER MORAL Y LA DISCIPLINA DE LAS PERSONAS. POR PARTE DEL ESTADO SE APLICA EL 
                        PROGRAMA DE EDUCACIÓN FÍSICA A NIVEL ESCOLAR CON EL PROPÓSITO DE FOMENTAR EL DEPORTE DESDE EL PRIMER 
                        NIVEL DE EDUCACIÓN EN 1944. 
                    </p>
                    <br>
                    <p class="fontMS100 font-24 text-white text-justify">
                        Manuel Prado señalaba al respecto: “El ejercicio es indispensable para crear los hábitos y destrezas corporales 
                        que tanto influyen en el mantenimiento de la salud y del vigor de la raza”. Se incluyeron en el calendario escolar 
                        concentraciones deportivas en las que se fomentaba la participación de los padres de familia en la formación de 
                        sus hijos. Este fue un esfuerzo descentralizado en sedes como Tacna, Arequipa, Cuzco, Ica, Chincha, Huancayo, Huaraz, 
                        Trujillo, Chiclayo, Cajamarca, Talara e Iquitos.
                    </p>
                    <br>
                    <p class="fontMS100 font-24 text-white text-justify">
                        Durante la posguerra, apareció de manera masiva la figura del aficionado dentro de la actividad del deporte. Son los 
                        seguidores que acompañaban y alentaban a equipos y figuras deportivas, sobre todo, a través de los medios de difusión. 
                        La expansión de clubes, ligas y asociaciones que se fundaron en todos los sectores de la sociedad captaron un nuevo público: el hincha.
                    </p>
                    <br><br>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71167" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/gHFH-TKgdA0/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Campeonato de fútbol de Primera...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71212" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/Xbz0N62FM5Y/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Botafogo vs Deportivo Municipal 
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71031" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/D7nUIWupZdU/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Regatas en Chorrillos
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70666" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/jNHP2SgjPGU/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Club de hawaianos
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70750" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/xhSgqURedcw/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Los ciclistas se entrenan
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="http://hdl.handle.net/20.500.14428/79322" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/mG2cs0pkQN8/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Lima: Carrera de automóviles
                        </p>
                    </div>
                </div>

                <br><br><br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br>

                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            DIVERSIONES PÚBLICAS
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    LAS FIESTAS TRADICIONALES
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="col-sm-12 mt-5">
                    <p class="fontMS100 font-24 text-white text-justify">
                        Los noticieros elegidos permiten reflexionar sobre las prácticas culturales y la vida cotidiana 
                        de los habitantes de Lima y del interior del país. Las actividades de esparcimiento son masivas. 
                        Sin embargo, cada una se realiza en sitios particulares con participación de sectores diferentes 
                        de la sociedad, un uso del espacio público que sugiere la construcción de una ciudadanía estratificada.
                        El incremento de la migración del campo hacia las ciudades cambiaría de manera definitiva la distribución 
                        demográfica en el Perú.
                    </p>
                    <br><br>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70617 " target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/A-tItK_H_RM/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            24 de junio: tradicional fiesta limeña
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70880" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/SAyRPaFwss8/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            El desfile de carros alegóricos
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70862" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/lR2NOIRhzPg/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Fiesta en La Atarjea
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71169" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/MR3i0AycQR4/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Sacsayhuamán revive las legendarias...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70679" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/MRHawwe2PoE/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            La feria del apóstol Santiago en...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71232" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/MvUi6zj_bEU/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Playas de Agua Dulce
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70593" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/Ttt0lnAdohI/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Verano en La Punta
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70838" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/Eb0inPZrm68/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Visiones de la ciudad de Ayaviri
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70657" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/6wlfKmdSBFY/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Mar y playa en Miraflores
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70529" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/TMK32nT8aI4/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Inti Raymi, fiesta milenaria
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="http://hdl.handle.net/20.500.14428/79321" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/ExWp0IP3Psw/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Carnavales 1945
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70619" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/3VdEc6g6x0Y/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            La tradicional fiesta de Amancaes
                        </p>
                    </div>
                </div>
                <br><br><br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br>

                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            LA MUJER MODERNA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                
                <div class="col-sm-12 mt-5">
                    <p class="fontMS500 font-24 text-white text-justify">
                        HACIA 1940, LA POBLACIÓN FEMENINA ERA POCO MÁS DE TRES MILLONES Y REPRESENTABA MÁS DE LA MITAD DE LA POBLACIÓN. 
                        EN LAS ÁREAS URBANAS LA EDUCACIÓN Y EL AUMENTO DE LA OFERTA LABORAL CONTRIBUYERON A TRASTOCAR LOS TRADICIONALES 
                        ROLES ASIGNADOS A LA MUJER EN LA SOCIEDAD. PIONERAS COMO MARÍA JESÚS ALVARADO, ZOILA AURORA CÁCERES O MAGDA PORTAL 
                        TUVIERON UNA DESTACADA LABOR, PROPUGNANDO LA IGUALDAD DE DERECHOS Y UNA MAYOR PARTICIPACIÓN EN LA POLÍTICA Y SU 
                        ESTRUCTURA PARTIDARIA.
                    </p>
                    <br>
                    <p class="fontMS100 font-24 text-white text-justify">
                        Aunque en el año de 1945 prosperó en el Parlamento una solicitud de reforma de la Constitución Política de 1933 para 
                        que las mujeres puedan sufragar en las elecciones presidenciales y congresales, solo hasta 1956 se consigue ese derecho, 
                        aunque únicamente a mayores de 21 años y casadas mayores de 18 que supieran leer y escribir. En contraposición a estas 
                        reivindicaciones, en el discurso oficial expuesto en los noticiarios se representa como trabajadora ligada a oficios como 
                        la salud y la educación, o se enfatiza en aspectos como su “belleza” y otras trivialidades. La difusión de estos roles sucedía 
                        conforme a los valores que imperaban en la sociedad peruana, los cuales tuvieron una extensa resonancia a través de la pantalla.
                    </p>
                    <br><br>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70621" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/DZmnEf1LLao/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Nota social
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71085" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/xvlfMfBFYKg/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Reina de los universitarios
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71189" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/hg96Ek4cKF8/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Coronación de la Reina del Trabajo
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71009" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/dHT27Dv-79E/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Señoritas limeñas exhiben modelos
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70945" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/k0bXIfBL_qU/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Primera promoción de flight hostesses
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70486" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/goy6nqCQI-I/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Cuerpo de auxiliares voluntarias en el...
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70572" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/vZZxbww3FkM/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Clausura del año académico en la...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71199" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/Db1n9-8xEJg/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            En el Teatro Municipal
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                    </div>
                </div>

                <br><br><br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br>

                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            CULTURA MODERNA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    Y PATRIMONIO ARQUEOLÓGICO
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="col-sm-12 mt-5">
                    <p class="fontMS500 font-24 text-white text-justify">
                        EL ESTABLECIMIENTO DE LOS PREMIOS DESTINADOS AL FOMENTO DE LA CULTURA, ESTABLECIDOS POR LA LEY N° 9614 DE 1942, 
                        EN EL GOBIERNO DE MANUEL PRADO, SIGNIFICAN EL APOYO DEL ESTADO A DIVERSAS CATEGORÍAS ARTÍSTICAS, LITERARIAS, MUSICALES 
                        Y DE INVESTIGACIÓN CIENTÍFICA.
                    </p>
                    <br>
                    <p class="fontMS100 font-24 text-white text-justify">
                        Se intentó establecer salvaguardas al patrimonio mediante el Patronato Nacional de Arqueología a través de inspectores de “ruinas” en 
                        sitios arqueológicos de Ancash, Ica, Lambayeque, La Libertad, Cuzco, Arequipa y Apurímac. En tanto, en Lima, la creciente expansión urbana 
                        conllevó a la destrucción sistemática de sus huacas, siendo utilizadas algunas de ellas como canteras para la elaboración de ladrillos. Los 
                        noticiarios privilegiaron las artes plásticas que, a finales de la década de 1940, se vieron influenciadas por estilos modernistas y universales 
                        que renovarían la plástica local.
                    </p>
                    <br><br>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70798" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/iSofU2nh0zM/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            En las ruinas de Chan Chan
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71133" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/iKjFGXxewYI/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            3 premios de la Cultura 1948
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71063" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/g6noj0IvKzw/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            En la Escuela de Bellas Artes
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71079" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/8d4JeYZI_Xk/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Inauguración de una galería de arte
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71276" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/FHIP0dHxMIg/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Primera Exposición Nacional de...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71047" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/AESy5HCP3Ys/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Exposición de arte fotográfico
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70707" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/m2bgZv4dan8/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Instalación del Instituto Indigenista...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70846" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/iiKu-CEwauY/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            En el Museo de Antropología y...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                    </div>
                </div>

                <br><br><br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br>

                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            INFRAESTRUCTURA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    Y SERVICIOS PÚBLICOS
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="col-sm-12 mt-5">
                    <p class="fontMS500 font-24 text-white text-justify">
                        EL REGISTRO FÍLMICO DE LOS PROCESOS DE MODERNIZACIÓN URBANA Y EXPANSIÓN DE LOS SERVICIOS PÚBLICOS MEDIANTE 
                        GRANDES OBRAS DE INFRAESTRUCTURA EVIDENCIA EL ROL DEL ESTADO PERUANO EN LA GESTIÓN DE RECURSOS Y LA DISTRIBUCIÓN 
                        DE BIENES.
                    </p>
                    <br>
                    <p class="fontMS100 font-24 text-white text-justify">
                        El gobierno de entonces, dependiente de la exportación de materias primas, y a pesar de la crisis económica 
                        producto de la Segunda Guerra Mundial (1939-1945), destinó una parte de su presupuesto a proyectos de salud 
                        y educación en zonas urbanas e, incluso, se propuso financiar carreteras y aeropuertos para lograr la integración 
                        del Perú. A través de las corporaciones de fomento, el Estado, como garante, comenzó a promocionar nuevos sectores 
                        económicos como el turismo, la aviación comercial o la construcción de viviendas.
                    </p>
                    <br><br>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71076" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/wLgx-S1U0NE/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Agua potable para un millón de...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71049" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/bDKp1l3nrsk/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Unidad Vecinal próxima a inaugurarse
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70949" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/wukUaxWnRf4/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Nueva central de la Asistencia Pública
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70686" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/fyOgc04hKjc/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Con la Corporación Nacional de...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/70885" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="http://img.youtube.com/vi/LlsFTsrGsds/hqdefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Inauguración del Estadio Melgar en...
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <a class="video" href="https://hdl.handle.net/20.500.14428/71278" target="_blank" style="color: black;">
                            <img width="100%" height="250" src="https://i.ytimg.com/vi/3nyW5J13AuM/sddefault.jpg" />
                        </a>
                        <p class="fontMS100Italic font-22 text-white">
                            Iquitos: entrega oficial del...
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-justify text-white font-28">
                            <br>
                            A partir de 1944, se proyectaban los noticiarios promovidos por el Estado peruano a una población
                            urbana a lo largo del país, lo cual aportó a conformar una conciencia colectiva de nación al exhibir
                            el territorio inmenso con una población y cultura diversa. Este material nos permite hoy reflexionar
                            y debatir.
                            <br><br>
                            Te invitamos a reflexionar sobre la migración y las epidemias, hechos cíclicos a lo largo de nuestra
                            historia que nos dejan aprendizajes que no debemos olvidar.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <div class="row mt-3">
                            <div class="col-sm-6 libro">
                                <a class="video2" href="https://hdl.handle.net/20.500.14428/71237" target="_blank" style="color: black;">
                                    <img width="100%" height="400" src="/assets/images/micrositio/micrositio18/NOTIC_VID_01.jpg" />
                                    <div class="overlay">
                                        <p class="fontMS100Italic font-22 text-center">
                                            Campaña antivariólica en Lima,<br>
                                            Callao y balnearios
                                        </p>
                                    </div>
                                </a>
                                <br><br>
                            </div>
                            <div class="col-sm-6 libro">
                                <a class="video2" href="https://hdl.handle.net/20.500.14428/70926" target="_blank" style="color: black;">
                                    <img width="100%" height="400" src="/assets/images/micrositio/micrositio18/NOTIC_VID_02.jpg" />
                                    <div class="overlay">
                                        <p class="fontMS100Italic font-22 text-center">
                                            Inmigrantes
                                        </p>
                                    </div>
                                </a>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Qué sabemos sobre las epidemias y su control a
                                través de la vacunación en nuestro país?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿De dónde es tu familia?,<br>
                            ¿Tuvieron que migrar?,<br>
                            ¿Cuáles fueron los motivos?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                La información es un bien público, ¿cómo te mantienes informado?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p class="fontMS100 font-22">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22">
                            <span class="fontMS500">
                                Bedoya, R. (2016)
                            </span><br>
                            <span>
                                El cine sonoro en el Perú.
                            </span>
                            <span class="fontMS100">Lima: Universidad de Lima, Fondo Editorial.
                                <br></span>
                            <a href="https://repositorio.ulima.edu.pe/handle/20.500.12724/10717" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Archivo Peruano de Imagen y Sonido
                            </span><br>
                            http://www.archivoperuano.com/ <br>
                            https://www.youtube.com/channel/UCXtJ5sZ
                            rJniNYXacZSTeBOw/videos<br>
                            <a href="https://www.youtube.com/channel/UCXtJ5sZrJniNYXacZSTeBOw/videos" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Mejía Ticona, Víctor (2007)
                            </span><br>
                            Ilusiones a oscuras. Cines en Lima: carpas,
                            grandes salas y multicines, 1897-2007
                            <span class="fontMS100">
                                Lima: Universidad Ricardo Palma<br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=345646"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Wiener, Christian (2015)
                            </span><br>
                            Estudio y propuesta sobre conservación y
                            difusión del material cinematográfico y
                            audiovisual peruano.
                            <span class="fontMS100">
                                Dirección del Audiovisual, la Fonografía y los Nuevos
                                Medios DAFO, Ministerio de Cultura del Perú. <br>
                            </span>
                            <a href="https://mailing.culturainforma.pe/lists/pdfpublic/informearchivosfilmicos/files/assets/basic-html/page-1.html" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Bignon, F. (2018)
                            </span><br>
                            Propaganda pradista: Patria, caídos y
                            Amazonía en torno a la guerra Perú-Ecuador de 1941.
                            <span class="fontMS100">
                                Boletín del Instituto Francés de
                                Estudios Andinos, vol. 47, núm.2, pp. 117-140
                                https://www.redalyc.org/journal/126/126585
                                12002/html/ <br>
                            </span>
                            <a href="https://www.redalyc.org/journal/126/12658512002/html/"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>